<template>
  <a-config-provider :theme="theme" :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>

<script setup lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

// 与 styles/global.css 中的设计令牌保持同一套取值，改配色时两处需同步。
const theme = {
  token: {
    colorPrimary: '#e84f7b',
    colorInfo: '#3b7fd4',
    colorSuccess: '#17915f',
    colorWarning: '#c97820',
    colorError: '#d33a4e',
    colorText: '#1c2029',
    colorBorder: '#e6e9ef',
    colorBorderSecondary: '#eef0f4',
    colorBgLayout: '#f4f6f9',
    borderRadius: 6,
    borderRadiusLG: 10,
    fontSize: 14,
    controlHeight: 34,
    wireframe: false,
  },
  components: {
    Table: { headerBg: '#f8fafc', headerSplitColor: 'transparent', rowHoverBg: '#fdf4f7' },
    Menu: { itemBorderRadius: 8, itemMarginInline: 10 },
    Tabs: { horizontalItemGutter: 26 },
  },
};
</script>
